'use client'

import { useTranslate } from '@repo/shared/hooks'
import { Col, Icon, Row, Typography } from '@repo/ui/components'
import { ButtonLink } from '@repo/shared/components'
import { useIsDesktop } from '@repo/ui/hooks'

export const AddProjectCTA = ({
  origin,
}: {
  origin: 'layout' | 'container'
}) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()
  return (
    <Col
      className={`${origin === 'layout' ? 'sticky top-0' : ''} bg-neutral-surface-light sm:bg-transparent  px-xs py-xs md:px-3xl  justify-between`}
    >
      {isDesktop && (
        <Row className='w-fit'>
          <ButtonLink
            variant='transparent'
            size='md'
            color='neutral'
            href='/projects'
            startIcon={<Icon name='ArrowRightLine' size='md' />}
          >
            {t('common_back')}
          </ButtonLink>
        </Row>
      )}
      <Row className='w-full justify-between'>
        {!isDesktop && (
          <ButtonLink
            variant='transparent'
            size='md'
            color='neutral'
            href='/projects'
            aria-label='Back to Wallet'
            startIcon={<Icon name='ArrowRightLine' size='md' />}
          >
            <Typography size='md' weight='bold'>
              {t('dashboardAgent_addProjectPage_title')}
            </Typography>
          </ButtonLink>
        )}

        {isDesktop && (
          <Typography
            variant='h3'
            size='2xl'
            weight='bold'
            color='text-neutral-main'
          >
            {t('dashboardAgent_addProjectPage_title')}
          </Typography>
        )}
      </Row>
    </Col>
  )
}
